import request from '@/utils/request'


// 首页
export function homeMenu(query) {
  return request({
    url: '/web/home/menu',
    method: 'get',
    params: query
  })
}
//新闻列表 /web/home/details
export function homeDetails(query) {
    return request({
      url: '/web/home/details',
      method: 'get',
      params:query
    })
}
//子新闻列表 hostNews
export function homeHostNews(query) {
    return request({
      url: '/web/home/hostNews',
      method: 'get',
      params:query
    })
}
//详情 /hostNews/{id}
export function homeHostNewsDetail(query) {
  return request({
    url: `/web/home/hostNews/${query.id}`,
    method: 'get'
  })
}
//党建新闻 construct
export function homeConstruct(query) {
  return request({
    url: '/web/home/construct',
    method: 'get',
    params:query
  })
}
//党建详情
export function homeConstructDetail(query) {
  return request({
    url: `/web/home/construct/${query.id}`,
    method: 'get'
  })
}
//岗位列表 position
export function homePosition(query) {
  return request({
    url: '/web/home/position',
    method: 'get',
    params:query
  })
}

export function homePositionDetail(query) {
  return request({
    url: `/web/home/position/${query.id}`,
    method: 'get'
  })
}

//员工风采 /hire/{id}
export function homeHireDetail(query) {
  return request({
    url: `/web/home/hire/${query.id}`,
    method: 'get'
  })
}

//专业方向详情 /technical/{id}
export function homeTechnicalDetail(query) {
  return request({
    url: `/web/home/technical/${query.id}`,
    method: 'get'
  })
}

//下载 resume
export function homeResume() {
  return request({
    url: `/web/home/resume`,
    method: 'get'
  })
}

//公开详情 /info/{id}
export function homeInfoDetail(query) {
  return request({
    url: `/web/home/info/${query.id}`,
    method: 'get'
  })
}

//动态列表
export function homeDynamics(query) {
  return request({
    url: '/web/home/dynamics',
    method: 'get',
    params:query
  })
}

//动态列表详情
export function homeDynamicsDetail(query) {
  return request({
    url: `/web/home/dynamics/${query.id}`,
    method: 'get'
  })
}

///web/online/send
export function homeOnlineSend(data) {
  return request({
    url: `/web/online/send`,
    method: 'post',
    data
  })
}
///web/online/default
export function homeOnlineDefault(data) {
  return request({
    url: `/web/online/default`,
    method: 'get',
    params:data
  })
}
///web/home/search?keyword=1
export function homeSearch(data) {
  return request({
    url: `/web/home/search`,
    method: 'get',
    params:data
  })
}


//资源列表
export function homeMaterialFile(query) {
  return request({
    url: '/web/home/materialFile/list',
    method: 'get',
    params:query
  })
}

//资源详情 http://localhost/dev-api/service/materialFile/18
export function homeMaterialFileDetail(query) {
  return request({
    url: `/web/home/materialFile/${query.id}`,
    method: 'get'
  })
}

//资讯文章 http://localhost/dev-api/service/article/list?pageNum=1&pageSize=10
//文章列表
export function homeArticleList(query) {
  return request({
    url: '/web/home/article/list',
    method: 'get',
    params:query
  })
}
//报道 front/list
export function homeFrontList(query) {
  return request({
    url: '/web/home/front/list',
    method: 'get',
    params:query
  })
}
//详情 /service/front/6
//报道详情 /service/front/6
export function homeFrontDetail(query) {
  return request({
    url: `/web/home/front/${query.id}`,
    method: 'get'
  })
}

//文章详情 http://localhost/dev-api/service/article/13
export function homeArticleDetail(query) {
  return request({
    url: `/web/home/article/${query.id}`,
    method: 'get'
  })
}

//车辆列表 http://localhost/dev-api/service/model/list?pageNum=1&pageSize=10
export function homeModelList(query) {
  return request({
    url: '/web/home/model/list',
    method: 'get',
    params:query
  })
}

//车辆详情 http://localhost/dev-api/service/model/13
export function homeModelDetail(query) {
  return request({
    url: `/web/home/model/${query.id}`,
    method: 'get'
  })
}


export function HomefileDownload(query) {
  return request({
    url: "/web/home/download",
    method: "get",
    params:query,
    responseType: "blob"
  });
}


